'use strict';
angular.module('gmComponentsModule', ['uiComponentsModule']);
